export default function removeDuplicateObjects(list, uniqueProp, timestampProp) {
  const reduced = list.reduce((map, item) => {
    const existing = map.get(item[uniqueProp]);
    if (!existing || new Date(item[timestampProp]) > new Date(existing[timestampProp])) {
      map.set(item[uniqueProp], item);
    }
    return map;
  }, new Map());

  return Array.from(reduced.values());
}